// extracted by mini-css-extract-plugin
export default {"fieldGroupSpacing":"SpecialEventsGroup_fieldGroupSpacing__kDPuG"};